import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadMercedesTimisoara";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-mercedes-timisoara/")({
  head: () => routeHead("/admin/upload-mercedes-timisoara/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
